// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_fex.actions.go

export const BULK_DELETE_VEX =
  "mondoo.policy.VulnerabilityExchange.BulkDeleteVex";
